import { render, staticRenderFns } from "./EmailChangeModalSection.vue?vue&type=template&id=a387308a"
import script from "./EmailChangeModalSection.vue?vue&type=script&lang=ts"
export * from "./EmailChangeModalSection.vue?vue&type=script&lang=ts"
import style0 from "./EmailChangeModalSection.vue?vue&type=style&index=0&id=a387308a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports